// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronCircleUp } from '@fortawesome/free-solid-svg-icons'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { faMapSigns } from '@fortawesome/free-solid-svg-icons'
import { faPaw } from '@fortawesome/free-solid-svg-icons'
import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons'
import { faTwitterSquare } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Buefy from 'buefy'
import VueAnalytics from 'vue-ua'
import SocialSharing from "vue-social-sharing"
import VueStickyDirective from 'vue-sticky-directive'
import { VueReCaptcha } from "vue-recaptcha-v3";

Vue.use(VueReCaptcha, { siteKey: "6LcR3fMbAAAAALZCDwsWnLRc9CMROXK_0UIJmx5I", 
                        loaderOptions: { autoHideBadge: true }
                       });
Vue.use(SocialSharing)
Vue.use(Buefy)
Vue.use(VueAnalytics, {
  appName: 'expedijob',
  appVersion: '1',
  trackingId: 'UA-129230135-1'
})

Vue.use(VueStickyDirective);

library.add(faChevronCircleUp, faHome, faMapSigns, faPaw, faArrowAltCircleRight, faFacebookSquare, faTwitterSquare, faSpinner)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.config.devtools = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js